import * as React from 'react';
import classNames from 'classnames';
import ImageWithFallback from './ImageWithFallback';
import PersistButton from './PersistButton';
import strings from 'owa-strings/owa-extensibility-strings';
import { ControlIcons } from 'owa-addins-icons';
import { IButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { isPersistentTaskpaneEnabled } from 'owa-addins-feature-flags';

const styles = require('./TaskPaneHeader.scss');

export interface TaskPaneHeaderProps {
    displayName: string;
    iconUrl: string;
    closeOnClick: () => void;
    isCalendar: boolean;
    isPersistable: boolean;
    isPersisted: boolean;
    togglePersist: () => void;
}

export default class TaskPaneHeader extends React.Component<TaskPaneHeaderProps, any> {
    private closeButton: IButton;

    public focusCloseButton() {
        if (this.closeButton) {
            this.closeButton.focus();
        }
    }

    render() {
        const { isCalendar } = this.props;

        return (
            <div
                className={classNames(
                    styles.addinPaneHeader,
                    isCalendar && styles.addinPaneHeaderCalendar
                )}>
                <ImageWithFallback
                    src={this.props.iconUrl}
                    width={32}
                    height={32}
                    className={styles.addinPaneIcon}
                />
                <div className={classNames([styles.addinPaneLabelText, styles.ellipsis])}>
                    {this.props.displayName}
                </div>
                <div className={styles.rightButtons}>
                    {isPersistentTaskpaneEnabled() && this.props.isPersistable && !isCalendar && (
                        <PersistButton
                            displayName={this.props.displayName}
                            isPersisted={this.props.isPersisted}
                            togglePersist={this.props.togglePersist}
                        />
                    )}
                    <IconButton
                        componentRef={ref => (this.closeButton = ref)}
                        className={styles.closeButton}
                        onClick={this.props.closeOnClick}
                        ariaLabel={strings.taskPaneCloseButtonAriaLabel}
                        iconProps={{ iconName: ControlIcons.Cancel }}
                    />
                </div>
            </div>
        );
    }
}
